<template>
  <div class="course-detail">
    <section class="header">
      <van-image class="bg" :src="detail.imageUrl" fit="cover" alt="背景图" />
    </section>
    <section class="summary">
      <div class="nums">
        <div class="item">
          <span class="desc">时长</span>
          <span class="val">
            <b>{{ ~~(detail.length / 60000) }}</b>
            分钟
          </span>
        </div>
        <div class="item">
          <span class="desc">课件</span>
          <span class="val">
            <b>{{ detail.unitCount }}</b>
            节
          </span>
        </div>
        <div class="item">
          <span class="desc">章节</span>
          <span class="val">
            <b>{{ detail.chapterCount }}</b>
            个
          </span>
        </div>
      </div>

      <div class="desc-val">
        <span class="desc">教学说明</span>
        <span class="val">{{ detail.teachSynopsis }}</span>
      </div>
    </section>
    <section class="chapter-list">
      <van-list class="list">
        <van-cell v-for="item in list" :key="item.id" @click="jump2list(item)">
          <ListItemCard :title="item.title" :img="item.imageUrl" :max-line="1">
            <template #desc>
              <div class="desc">
                <span class="ell-2">{{ item.synopsis }}</span>
              </div>
            </template>
          </ListItemCard>
        </van-cell>
      </van-list>
    </section>
  </div>
</template>

<script>
import { knowledgeList, encyclopediaCoursePage } from '@/services';

export default {
  data() {
    return {
      query: {},
      detail: {},
      list: [],

      loading: false,
      finished: false
    };
  },

  mounted() {
    const { query } = this.$route || {};
    this.query = query;
    this.getCourseList();
    this.getCourseDetail();
  },

  methods: {
    // 这里需要单独重新请求课程的详情信息，避免前一个页面通过model传递，刷新页面丢失的问题
    async getCourseList() {
      const params = { classId: this.query.classId };
      const res = await encyclopediaCoursePage(params);
      this.detail = res.dataList[this.query.index];
    },
    async getCourseDetail() {
      const params = { courseId: this.query.courseId, type: this.query.type };
      const res = await knowledgeList(params);
      this.list = res.dataList;
    },
    jump2list({ id }) {
      this.$router.push(`/course/chapter?id=${id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.course-detail {
  .header {
    width: 100%;
    height: 140px;
    .bg {
      height: 100%;
      width: 100%;
    }
  }
  .summary {
    width: 100%;
    max-height: 182px;
    background: #ffffff;
    padding: 0 12px;
    padding-bottom: 20px;
  }

  .desc-val {
    display: flex;
    flex-direction: column;
    .desc {
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 16px;
      margin-bottom: 4px;
    }
    .val {
      font-size: 12px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 17px;
    }
  }
  .nums {
    height: 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .desc {
      font-size: 12px;
      color: #8c8c8c;
      line-height: 14px;
    }
    b {
      font-size: 24px;
      font-weight: 400;
      line-height: 29px;
    }
    .val {
      font-size: 12px;
      color: #333333;
      line-height: 14px;
    }
  }
  .chapter-list {
    margin-top: 10px;
  }
}
</style>

<style lang="less">
.course-detail {
  .list {
    .van-cell {
      padding: 16px;
    }
  }
  .list-item-card {
    .left img {
      width: 90px;
      height: 60px;
    }
  }
  .right {
    .title {
      margin-bottom: 6px;
    }
  }
}
</style>
